export const DIFFICULTIES = [
  {
    id: 0,
    name: 'Usoară',
    key: 'easy-difficulty',
  },
  {
    id: 1,
    name: 'Medie',
    key: 'medium-difficulty',
  },
  {
    id: 2,
    name: 'Grea',
    key: 'hard-difficulty',
  },
]

export const DIFFICULTIES_INTERVALS = {
  EASY: {
    minValue: 0.87,
    maxValue: 1,
  },
  MEDIUM: {
    minValue: 0.29,
    maxValue: 0.87,
  },
  HARD: {
    minValue: 0,
    maxValue: 0.29,
  },
}
